import chroma from 'chroma-js';

import {
  titleOptions,
  tooltipOptions,
  getBins,
  generatePlayerKey,
} from '../../../shared/chart-options';
import { HeatmapTooltip } from '../HeatmapTooltip';

export function getHeatmapOptions(config, combinations, players) {
  const data = combinations.map(combination => combination[config.property]);
  const seriesData = getHeatmapSeriesData(
    config.property,
    combinations,
    players,
  );
  const colorFormatter = getHeatmapColorFormatter(data, config.colors);

  return getHeatmapEChartOptions(
    config.name,
    players,
    seriesData,
    colorFormatter,
  );
}

function getHeatmapEChartOptions(name, players, data, colorFormatter) {
  return {
    ...titleOptions(name),
    legend: { show: false },
    animation: false,
    grid: {
      top: 50,
      bottom: 5,
      left: 40,
      right: 10,
    },
    xAxis: {
      data: players,
      type: 'category',
      position: 'top',
      axisLabel: {
        interval: 0,
        fontSize: 10,
      },
    },
    yAxis: {
      data: players.map(player => player.replace('\n', '')),
      type: 'category',
      inverse: true,
      axisLabel: {
        interval: 0,
        fontSize: 10,
      },
    },
    tooltip: {
      ...tooltipOptions,
      formatter: HeatmapTooltip,
    },
    series: [
      {
        type: 'heatmap',
        data,
        itemStyle: {
          color: colorFormatter,
          emphasis: {
            shadowBlur: 10,
            shadowColor: 'rgba(0, 0, 0, 0.5)',
          },
        },
      },
    ],
  };
}

function getHeatmapSeriesData(property, combinations, players) {
  return combinations.map(combination => {
    const indexOfPlayer1 = players.indexOf(
      generatePlayerKey(combination.player1),
    );
    const indexOfPlayer2 = players.indexOf(
      generatePlayerKey(combination.player2),
    );

    const coordinates =
      indexOfPlayer1 <= indexOfPlayer2
        ? [indexOfPlayer1, indexOfPlayer2]
        : [indexOfPlayer2, indexOfPlayer1];

    return [...coordinates, combination[property], property, combination];
  });
}

function getHeatmapColorFormatter(seriesData, colors) {
  const bins = getBins(seriesData);

  return ({ value }) => {
    const valueBin = bins.find(bin => bin.indexOf(value[2]) !== -1);
    const colorIndex = bins.indexOf(valueBin);

    return chroma.scale(colors).colors(bins.length)[colorIndex];
  };
}
